import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import bnr_logo from "../../assets/images/bnr_logo.png";

const exportToExcel = async (
  excelTitle,
  userAccountInfo,
  exchange,
  date,
  tableHeaders,
  tableBody,
  tableTitle2,
  
  tableHeaders2,
  tableBody2,
  expenseTable ,
  tableHeaders3
  
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");
  

  const totalColumns = 8; // Adjust based on your table column count
  // ✅ Set Default Font to Montserrat for Entire Worksheet
  worksheet.properties.defaultRowHeight = 18;
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.font = { name: "Montserrat", size: 11 };
    });
  });

  // Merge first row across all columns
  worksheet.mergeCells(`A1:H1`); // Adjust range dynamically if needed
  worksheet.getRow(1).height = 50; // Increase row height to fit image

  const response = await fetch(bnr_logo);
  const imageBlob = await response.blob();
  const imageBuffer = await imageBlob.arrayBuffer();

  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

  // Insert the image in the center of the merged row
  worksheet.addImage(imageId, {
    tl: { col: 2, row: 0 }, // Adjusted to center in merged row
    ext: { width: 400, height: 50 }, // Keep original size or adjust if needed
  });

  // Center align text inside merged cell
  const headerCell = worksheet.getCell("A1");
  headerCell.alignment = { horizontal: "center", vertical: "middle" };

  // ======= ADDRESS =======
  worksheet.mergeCells("A2:H2");
  worksheet.getCell("A2").value =
    "6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES, SOMAJIGUDA, HYDERABAD-500082";
  worksheet.getCell("A2").font = {
    bold: true,
    name: "Montserrat",
    size: 12,
    color: { argb: "515C65" },
  };
  worksheet.getCell("A2").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // ======= REPORT TITLE (Only 1 Column Wide) =======
  worksheet.mergeCells("A4:B4");
  worksheet.getCell("A4").value = `${excelTitle}`;
  worksheet.getCell("A4").font = {
    bold: true,
    size: 16,
    color: { argb: "FFFFFF" },
    name: "Montserrat"
  };
  worksheet.getCell("A4").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1261A6" }, // Blue background
  };
  worksheet.getCell("A4").alignment = {
    horizontal: "left",
    vertical: "middle",
  };

  // Increase the row height for better visibility
  worksheet.getRow(4).height = 30; // Adjust height as needed

  worksheet.addRow([]); // Empty row for spacing

  // ======= ACCOUNT INFO SECTION =======
  worksheet.getCell("A6").value = "Account Name:";
  worksheet.getCell("A6").font = { bold: true,name: "Montserrat" };
  worksheet.getCell("B6").value = userAccountInfo?.name;

  worksheet.getCell("A7").value = "Client ID:";
  worksheet.getCell("A7").font = { bold: true, name: "Montserrat" };
  worksheet.getCell("B7").value = userAccountInfo?.trade?.short_code;

  worksheet.getCell("A8").value = "Address:";
  worksheet.getCell("A8").font = { bold: true, name: "Montserrat" };
  worksheet.getCell(
    "B8"
  ).value = `${userAccountInfo?.personal_details?.address?.line_one}`;
  worksheet.getCell(
    "B9"
  ).value = `${userAccountInfo?.personal_details?.address?.line_two}`;
  worksheet.getCell(
    "B10"
  ).value = `${userAccountInfo?.personal_details?.address?.line_three}`;
  worksheet.getCell(
    "B11"
  ).value = `${userAccountInfo?.personal_details?.address?.line_four}`;

  // Contact Details in Second Half
  worksheet.getCell("E6").value = "Email:";
  worksheet.getCell("E6").font = { bold: true,name: "Montserrat" };
  worksheet.getCell("F6").value =
    userAccountInfo?.personal_details?.email || "N/A";

  worksheet.getCell("E7").value = "Phone:";
  worksheet.getCell("E7").font = { bold: true,name: "Montserrat" };
  worksheet.getCell("F7").value =
    userAccountInfo?.personal_details?.phone || "N/A";

  if (exchange && exchange.trim() !== "") {
    worksheet.getCell("E8").value = "Exchange:";
    worksheet.getCell("E8").font = { bold: true,name: "Montserrat" };
    worksheet.getCell("F8").value = exchange;
  }

  worksheet.addRow([]); // Empty row for spacing

  // Date Center Aligned
  worksheet.mergeCells("A13:H13");
  worksheet.getCell("A13").value = `${date}`;
  worksheet.getCell("A13").font = { bold: true,name: "Montserrat" };
  worksheet.getCell("A13").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.addRow([]); // Empty row for spacing


  // if (tableTitle) {
  //   const firstTableStartRow = worksheet.rowCount + 1;
  
  //   const lastCol = String.fromCharCode(65 + tableHeaders.length - 1); // A=65 in ASCII
  //   worksheet.mergeCells(`A${firstTableStartRow}:${lastCol}${firstTableStartRow}`);
  
  //   worksheet.getCell(`A${firstTableStartRow}`).value = tableTitle;
  //   worksheet.getCell(`A${firstTableStartRow}`).font = {
  //     size: 11,
  //     bold: true,
  //     name: "Montserrat",
  //   };
  //   worksheet.getCell(`A${firstTableStartRow}`).alignment = {
  //     horizontal: "left", /
  //     vertical: "middle",
  //   };
  
    
  //   worksheet.addRow([]);
  // }
  

  // ======= TABLE HEADER =======

  const numericColumnIndexes = [];
tableBody[0]?.forEach((value, index) => {
  if (!isNaN(value) && value !== "") {
    numericColumnIndexes.push(index);
  }
});
  const headerRow = worksheet.addRow(tableHeaders);
headerRow.eachCell((cell, colNumber) => {
  const isNumeric = numericColumnIndexes.includes(colNumber - 1);

  cell.font = { bold: true, name: "Montserrat", color: { argb: "FFFFFF" } };
  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1261A6" },
  };
  cell.alignment = {
    horizontal: isNumeric ? "right" : "left",
    vertical: "middle",
  };
});





  // ======= TABLE BODY =======
  let totalRowIndex = null;
  tableBody.forEach((row) => {
    let newRow = worksheet.addRow(row);
    newRow.eachCell((cell, colNumber) => {
      let cellValue = row[colNumber - 1];
      if (typeof cellValue === "string" && cellValue.includes(",")) {
        cellValue = parseFloat(cellValue.replace(/,/g, ""));
        cell.value = cellValue; // Assign the converted number
      }
  
      // Check if it's a number and align properly
      if (!isNaN(cellValue) && cellValue !== "") {
        cell.alignment = { horizontal: "right" };
        cell.numFmt = "#,##0.00"; // Format as a number with commas
      } else {
        cell.alignment = { horizontal: "left" };
      }
     
    });

    if (row[0]?.toString().toLowerCase() === "total") {
      totalRowIndex = newRow.number;
    }
  });

  // ======= ENTIRE TOTAL ROW GREEN BACKGROUND =======
  if (totalRowIndex !== null) {
    const totalRow = worksheet.getRow(totalRowIndex);
    totalRow.eachCell((cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFF" }, name: "Montserrat" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0FA67B" }, // Green background
      };

      // Left align the first column (Total text), right align the rest
      cell.alignment = {
        horizontal: colNumber === 1 ? "left" : "right",
        vertical: "middle",
      };
    });
  }

  worksheet.addRow([]); // Empty row for spacing
  // ======= SECOND TABLE HEADER =======
  if (tableHeaders2 && tableHeaders2.length > 0) {
    // ======= SECOND TABLE TITLE =======
    const secondTableStartRow = worksheet.rowCount + 1;
    // worksheet.mergeCells(`A${secondTableStartRow}:H${secondTableStartRow}`);
    worksheet.getCell(`A${secondTableStartRow}`).value = tableTitle2;
    worksheet.getCell(`A${secondTableStartRow}`).font = {
      size: 11,
      bold: true,
      name: "Montserrat"
    };
    worksheet.getCell(`A${secondTableStartRow}`).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    // worksheet.addRow([]); // Empty row for spacing before the second table
    const headerRow2 = worksheet.addRow(tableHeaders2);
    headerRow2.eachCell((cell) => {
      cell.font = { bold: true,name: "Montserrat", color: { argb: "FFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1261A6" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // ======= SECOND TABLE BODY =======
    let totalRowIndex2 = null;
    tableBody2?.forEach((row) => {
      let newRow = worksheet.addRow(row);
      newRow.eachCell((cell, colNumber) => {
        let cellValue = row[colNumber - 1];
        if (typeof cellValue === "string" && cellValue.includes(",")) {
          cellValue = parseFloat(cellValue.replace(/,/g, ""));
          cell.value = cellValue; // Assign the converted number
        }
    
        // Check if it's a number and align properly
        if (!isNaN(cellValue) && cellValue !== "") {
          cell.alignment = { horizontal: "right" };
          cell.numFmt = "#,##0.00"; // Format as a number with commas
        } else {
          cell.alignment = { horizontal: "left" };
        }
       
      });
  
      if (row[0]?.toString().toLowerCase() === "total") {
        totalRowIndex2 = newRow.number;
      }
    });

  // ======= ENTIRE TOTAL ROW GREEN BACKGROUND =======
  if (totalRowIndex2 !== null) {
    const totalRow = worksheet.getRow(totalRowIndex2);
    totalRow.eachCell((cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFF" }, name: "Montserrat" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0FA67B" }, // Green background
      };

      // Left align the first column (Total text), right align the rest
      cell.alignment = {
        horizontal: colNumber === 1 ? "left" : "right",
        vertical: "middle",
      };
    });
  }

    worksheet.addRow([]); // Empty row after the second table to avoid footer overlap
  }

  // ======= THIRD TABLE =======
if (expenseTable && expenseTable?.length > 0) {
  const thirdTableStartRow = worksheet.rowCount + 1;

  // ======= THIRD TABLE TITLE =======
  worksheet.getCell(`A${thirdTableStartRow}`).value = tableHeaders3;
  worksheet.getCell(`A${thirdTableStartRow}`).font = {
    size: 11,
    bold: true,
    name: "Montserrat",
  };
  worksheet.getCell(`A${thirdTableStartRow}`).alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // ======= THIRD TABLE HEADERS =======
  const headerRow3 = worksheet.addRow(["Particulars", "Amount"]);
  headerRow3.eachCell((cell) => {
    cell.font = { bold: true, name: "Montserrat", color: { argb: "FFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "1261A6" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
  });

  // ======= THIRD TABLE BODY =======
  let totalRowIndex3 = null;

  expenseTable?.forEach((item) => {
    const row = worksheet.addRow([item.label, item.key]);

    row.eachCell((cell, colNumber) => {
      const cellValue = colNumber === 2 ? parseFloat(item.key.toString().replace(/,/g, "")) : item.label;

      if (colNumber === 2 && !isNaN(cellValue)) {
        cell.value = cellValue;
        cell.alignment = { horizontal: "right" };
        cell.numFmt = "#,##0.00";
      } else {
        cell.value = item.label;
        cell.alignment = { horizontal: "left" };
      }
    });

    // Check if the row is a "Total" row
    if (item?.label.toLowerCase() === "total") {
      totalRowIndex3 = row.number;
    }
  });

  

  worksheet.addRow([]); // Empty row after the third table
}
  // ======= FOOTER =======
  const footerStart = worksheet.rowCount + 2; // Ensure footer starts at a safe distance

  worksheet.mergeCells(`A${footerStart}:H${footerStart}`);
  worksheet.getCell(`A${footerStart}`).value =
    "Your running account authorization would continue until it is revoked by you.";
  worksheet.getCell(`A${footerStart}`).font = {
    size: 11,
    name: "Montserrat"
    // color: { argb: "6F7982" },
  };

  worksheet.mergeCells(`A${footerStart + 1}:H${footerStart + 1}`);
  worksheet.getCell(`A${footerStart + 1}`).value =
    "COMPLIANCE OFFICER DETAILS: G SABITHA REDDY, Phone No: 040-40526277, 9703703399,";
  worksheet.getCell(`A${footerStart + 1}`).font = {
    size: 11,
    name: "Montserrat"
    // color: { argb: "6F7982" },
  };

  worksheet.mergeCells(`A${footerStart + 2}:H${footerStart + 2}`);
  worksheet.getCell(`A${footerStart + 2}`).value =
    " E-Mail ID: compliance@bnrsecurities.com, investorgrievances@bnrsecurities.com";
  worksheet.getCell(`A${footerStart + 2}`).font = {
    size: 11,
    name: "Montserrat"
    // color: { argb: "6F7982" },
  };

  worksheet.mergeCells(`A${footerStart + 3}:H${footerStart + 3}`);
  worksheet.getCell(`A${footerStart + 3}`).value =
    "Error or Discrepancy, if any, in the above statement should be reported to us within 30 days from the date of Receipt.";
  worksheet.getCell(`A${footerStart + 3}`).font = {
    size: 11,
    name: "Montserrat"
    // color: { argb: "6F7982" },
  };

  worksheet.mergeCells(`A${footerStart + 5}:H${footerStart + 5}`);
  worksheet.getCell(`A${footerStart + 5}`).value = "**End of the Report**";
  worksheet.getCell(`A${footerStart + 5}`).font = {
    size: 11,
    name: "Montserrat",
    bold: true,
    // color: { argb: "6F7982" },
  };
  worksheet.getCell(`A${footerStart + 5}`).alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // Auto-Adjust Column Widths Based on Table Headers
  worksheet.columns = tableHeaders.map(() => ({ width: 20 }));

  // Generate Excel File
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${excelTitle}.xlsx`);
};

export default exportToExcel;
